/**
 * Reusable, self-explanatory campaign-code tag.
 *
 * A bare code like "26SITFA99B" is meaningless on its own, so wherever a campaign
 * code is shown across the platform we pair it with its canal and lieu (région)
 * written small underneath — consistent with the Dashboard breakdown table.
 */
export function CampaignCodeTag({ code, canal, region, label, size = 'sm', testid }) {
  const sub = [canal, region].filter(Boolean).join(' \u00b7 ');
  const codeCls = size === 'md' ? 'text-xs' : 'text-[11px]';
  return (
    <div
      className="inline-flex max-w-[220px] flex-col rounded-lg border bg-muted/40 px-2 py-1 leading-tight"
      title={label || code}
      data-testid={testid}>
      <span className={`truncate font-mono font-semibold text-foreground ${codeCls}`}>{code}</span>
      {sub && <span className="truncate text-[9px] text-muted-foreground">{sub}</span>}
    </div>
  );
}
